import { FiActivity, FiAlertCircle, FiCamera, FiPower, FiTrendingUp } from "react-icons/fi";
import { useCameraContext } from "../../../context/CameraContext";

export default function CameraHealthHeader({ total, online, offline, inactive, healthScore }) {
  const { setFilterStatus, setViewMode } = useCameraContext();


  return (
    <div className="vmx-card p-6 relative overflow-hidden">
      {/* subtle background */}
      <div className="absolute -top-16 -right-16 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-emerald-500/10 rounded-full blur-3xl" />

      <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
        <div>
          <div className="flex items-center gap-3">
            <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight">
              Camera Command Center
            </h1>
            <span className="vmx-chip bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20">
              <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
              Live
            </span>
          </div>
          <div className="text-sm text-gray-600 dark:text-slate-400 mt-2 max-w-2xl">
            SOC-style monitoring: health, live streams, events, recordings and diagnostics — in one workspace.
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 w-full lg:w-auto">
          <Kpi
            label="Total"
            value={total}
            icon={FiCamera}
            onClick={() => setFilterStatus("")}
          />
          <Kpi
            label="Online"
            value={online}
            icon={FiActivity}
            tone="emerald"
            onClick={() => setFilterStatus("online")}
          />
          <Kpi
            label="Offline"
            value={offline}
            icon={FiAlertCircle}
            tone="red"
            onClick={() => setFilterStatus("offline")}
          />
          <Kpi
            label="Inactive"
            value={inactive}
            icon={FiPower}
            tone="amber"
            onClick={() => setFilterStatus("inactive")}
          />
          <HealthScore score={healthScore} onClick={() => setViewMode("wall")} />
        </div>
      </div>
    </div>
  );
}

function Kpi({ label, value, icon: Icon, tone = "slate", onClick }) {
  const toneMap = {
    slate: "bg-slate-500/10 text-slate-700 dark:text-slate-200 border-slate-500/15",
    emerald: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/15",
    red: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/15",
    amber: "bg-amber-500/10 text-amber-800 dark:text-amber-300 border-amber-500/15",
  };

  return (
    <button
      onClick={onClick}
      className={`p-3 rounded-xl border ${toneMap[tone]} text-left hover:opacity-95 transition`}
      title="Click to filter"
    >
      <div className="flex items-center justify-between">
        <div className="text-xs font-semibold opacity-80">{label}</div>
        <Icon className="opacity-70" />
      </div>
      <div className="text-2xl font-extrabold">{value}</div>
    </button>
  );
}

function HealthScore({ score, onClick }) {
  const tag =
    score >= 90 ? "Excellent" : score >= 70 ? "Good" : score >= 40 ? "Warning" : "Critical";

  return (
    <button
      onClick={onClick}
      className="p-3 rounded-xl border bg-gradient-to-br from-emerald-500/10 to-blue-500/10 border-blue-500/15 text-left hover:opacity-95 transition"
      title="Open wall view"
    >
      <div className="flex items-center justify-between">
        <div className="text-xs font-semibold opacity-80">Health</div>
        <FiTrendingUp className="opacity-70" />
      </div>
      <div className="text-2xl font-extrabold">{score}%</div>
      <div className="text-xs opacity-70">{tag}</div>
    </button>
  );
}

